import type { SigningStatus } from "@/shared/types";
import { isDraftSigningStatus } from "@/shared/utils";

export interface OrderActionsConfig {
  showDownloadButton: boolean;
  showSignButton: boolean;
  showCancelSigningButton: boolean;
}

export function getOrderActions(signingStatus: SigningStatus | null): OrderActionsConfig {
  if (isDraftSigningStatus(signingStatus)) {
    return {
      showDownloadButton: true,
      showSignButton: true,
      showCancelSigningButton: signingStatus === 0,
    };
  }

  return {
    showDownloadButton: false,
    showSignButton: false,
    showCancelSigningButton: false,
  };
}
